export default __webpack_public_path__ + "static/media/100_ml.fdbc4494.svg";